import { Footer } from '../../footer';
import { Header } from '../../header';
import { LayoutContainer } from '../layout-container';

import styles from './styles.module.scss';

export const LayoutWrapper = () => {
	return (
		<div className={styles.layoutWrapper}>
			<Header />
			<LayoutContainer />
			<Footer loggedIn />
		</div>
	);
};
